import type { ExternalPriceResponseType, ExternalPricePayloadType } from "../../utils/externalPriceTypes";

export const USC_EXT_PRICE_SET_SHOW = "externalPrice/setShow";
export const USC_EXT_PRICE_SET_DATA = "externalPrice/setData";
export const USC_EXT_PRICE_FAILED = "externalPrice/setFailed";
export const USC_EXT_PRICE_SET_FETCHING = "externalPrice/setFetching";
export const USC_EXT_PRICE_SET_LOCATION = "externalPrice/setLocation";
export const USC_EXT_PRICE_CALCULATE = "externalPrice/calculate";

type UscExtPriceSetShow = { type: typeof USC_EXT_PRICE_SET_SHOW; show: boolean };
type UscExtPriceSetData = {
    type: typeof USC_EXT_PRICE_SET_DATA;
    data: ExternalPriceResponseType | null;
    payload: ExternalPricePayloadType;
};
type UscExtPriceSetFailed = {
    type: typeof USC_EXT_PRICE_FAILED;
    failed: boolean;
    payload: ExternalPricePayloadType;
    errorMessage: string | null;
};
type UscExtPriceSetFetching = { type: typeof USC_EXT_PRICE_SET_FETCHING; fetching: boolean };
export type UscExtPriceSetLocation = { type: typeof USC_EXT_PRICE_SET_LOCATION; locationId: string | null };
export type UscExtPriceCalculate = { type: typeof USC_EXT_PRICE_CALCULATE };

export const setExternalPriceShow = (show: boolean): UscExtPriceSetShow => ({
    type: USC_EXT_PRICE_SET_SHOW,
    show,
});
export const setExternalPriceData = (
    data: ExternalPriceResponseType | null,
    payload: ExternalPricePayloadType,
): UscExtPriceSetData => ({
    type: USC_EXT_PRICE_SET_DATA,
    data,
    payload,
});
export const setExternalPriceFailed = (
    failed: boolean,
    payload: ExternalPricePayloadType,
    errorMessage: string | null = null,
): UscExtPriceSetFailed => ({
    type: USC_EXT_PRICE_FAILED,
    payload,
    failed,
    errorMessage,
});
export const setExternalPriceFetching = (fetching: boolean): UscExtPriceSetFetching => ({
    type: USC_EXT_PRICE_SET_FETCHING,
    fetching,
});
export const setUserTaxLocation = (locationId: string | null): UscExtPriceSetLocation => ({
    type: USC_EXT_PRICE_SET_LOCATION,
    locationId,
});
export const calculateExternalPrice = (): UscExtPriceCalculate => ({ type: USC_EXT_PRICE_CALCULATE });

export type UscExternalPriceActionsType =
    | UscExtPriceSetData
    | UscExtPriceSetFailed
    | UscExtPriceSetShow
    | UscExtPriceSetFetching
    | UscExtPriceSetLocation
    | UscExtPriceCalculate;
